import { StandardPage } from './StandardPage';

export * from './useNoClientDescription';

export default StandardPage;
